/* RESPONSIBLE TEAM: team-channels */
import AccountRouteBase from 'embercom/routes/apps/app/account/base/account-route-base';
import { inject as service } from '@ember/service';

export default AccountRouteBase.extend({
  intl: service(),
  analytics: {
    section: 'your_account',
    place: 'two_factor_auth',
  },
  get titleToken() {
    return this.intl.t('apps.app.account.two-factor-auth.setup');
  },
  setupController(controller, model) {
    this._super(...arguments);
    model.getTwoFactorQRCodeSVG();
  },
});
